import { useState } from 'react';
import '../../styles/Admin.css';
import '../../styles/HomeAdmin.css';
import { useHomeConfig, useAllTestimonials } from '../../context/HomeConfigContext';
import { TESTIMONIALS } from '../../data/testimonials.js';
import img1 from '../../images/Estudio/1.jpeg';
import img2 from '../../images/Estudio/2.jpeg';
import img3 from '../../images/Estudio/3.jpeg';
import img4 from '../../images/Estudio/4.jpeg';
import img5 from '../../images/Estudio/5.jpeg';
import img6 from '../../images/Estudio/6.jpeg';
import img7 from '../../images/Estudio/7.jpeg';

const ESTUDIO_IMAGES = [
  { index: 0, src: img1, label: 'Estudio 1' },
  { index: 1, src: img2, label: 'Estudio 2' },
  { index: 2, src: img3, label: 'Estudio 3' },
  { index: 3, src: img4, label: 'Estudio 4' },
  { index: 4, src: img5, label: 'Estudio 5' },
  { index: 5, src: img6, label: 'Estudio 6' },
  { index: 6, src: img7, label: 'Estudio 7' },
];

const SECTIONS = [
  { id: 'galeria', label: 'Galería (Modelos)', icon: 'photo_library' },
  { id: 'estudio', label: 'Estudio', icon: 'apartment' },
  { id: 'beneficios', label: 'Beneficios', icon: 'star' },
  { id: 'testimonios', label: 'Testimonios', icon: 'format_quote' },
];

function HomeAdminPage() {
  const { config, setConfig, galleryModels, saveConfigToApi } = useHomeConfig();
  const [activeSection, setActiveSection] = useState('galeria');
  const [showToast, setShowToast] = useState(false);
  const [saving, setSaving] = useState(false);

  const toggleGaleria = (id) => {
    setConfig((prev) => {
      const arr = prev.galeria.includes(id)
        ? prev.galeria.filter((x) => x !== id)
        : [...prev.galeria, id];
      return { ...prev, galeria: arr };
    });
  };

  const selectAllGaleria = () => {
    setConfig((prev) => ({ ...prev, galeria: galleryModels.map((m) => m.id) }));
  };

  const deselectAllGaleria = () => {
    setConfig((prev) => ({ ...prev, galeria: [] }));
  };

  const toggleEstudio = (index) => {
    setConfig((prev) => {
      const arr = prev.estudio.includes(index)
        ? prev.estudio.filter((x) => x !== index)
        : [...prev.estudio, index].sort((a, b) => a - b);
      return { ...prev, estudio: arr };
    });
  };

  const selectAllEstudio = () => {
    setConfig((prev) => ({ ...prev, estudio: [0, 1, 2, 3, 4, 5, 6] }));
  };

  const toggleBeneficios = (modelId) => {
    setConfig((prev) => {
      if (prev.beneficios.includes(modelId)) {
        return { ...prev, beneficios: prev.beneficios.filter((x) => x !== modelId) };
      }
      if (prev.beneficios.length >= 4) return prev;
      return { ...prev, beneficios: [...prev.beneficios, modelId] };
    });
  };

  const toggleTestimonials = (id) => {
    setConfig((prev) => {
      const arr = prev.testimonials.includes(id)
        ? prev.testimonials.filter((x) => x !== id)
        : [...prev.testimonials, id];
      return { ...prev, testimonials: arr };
    });
  };

  const selectAllTestimonials = () => {
    setConfig((prev) => ({ ...prev, testimonials: allTestimonials.map((t) => t.id) }));
  };

  const deselectAllTestimonials = () => {
    setConfig((prev) => ({ ...prev, testimonials: [] }));
  };

  const allTestimonials = useAllTestimonials();
  const [showTestimonialModal, setShowTestimonialModal] = useState(false);
  const [editingTestimonialId, setEditingTestimonialId] = useState(null);
  const [tForm, setTForm] = useState({ name: '', tag: '', preview: '', experience: '', modelId: null });

  const openNewTestimonial = () => {
    setEditingTestimonialId(null);
    setTForm({ name: '', tag: '', preview: '', experience: '', modelId: null });
    setShowTestimonialModal(true);
  };

  const openEditTestimonial = (item) => {
    setEditingTestimonialId(item.id);
    const foundModel = galleryModels.find((m) => m.src === item.image);
    setTForm({
      name: item.name || '',
      tag: item.tag || '',
      preview: item.preview || '',
      experience: item.experience || '',
      modelId: foundModel ? foundModel.id : (item.modelId || null),
    });
    setShowTestimonialModal(true);
  };

  const closeTestimonialModal = () => {
    setShowTestimonialModal(false);
    setEditingTestimonialId(null);
  };

  const saveTestimonial = () => {
    if (!tForm.name.trim() || !tForm.experience.trim()) return;
    const selectedModel = galleryModels.find((m) => m.id === tForm.modelId);

    if (editingTestimonialId !== null) {
      const isOriginal = TESTIMONIALS.some((t) => t.id === editingTestimonialId);
      if (isOriginal) {
        setConfig((prev) => ({
          ...prev,
          testimonialEdits: {
            ...prev.testimonialEdits,
            [editingTestimonialId]: {
              name: tForm.name.trim(),
              tag: tForm.tag.trim(),
              preview: tForm.preview.trim(),
              experience: tForm.experience.trim(),
              modelId: tForm.modelId,
            },
          },
        }));
      } else {
        setConfig((prev) => ({
          ...prev,
          customTestimonials: prev.customTestimonials.map((ct) =>
            ct.id === editingTestimonialId
              ? {
                  ...ct,
                  name: tForm.name.trim(),
                  tag: tForm.tag.trim(),
                  preview: tForm.preview.trim(),
                  experience: tForm.experience.trim(),
                  modelId: tForm.modelId,
                  image: selectedModel ? selectedModel.src : ct.image,
                }
              : ct
          ),
        }));
      }
    } else {
      const newId = `custom-t-${Date.now()}`;
      const newItem = {
        id: newId,
        name: tForm.name.trim(),
        tag: tForm.tag.trim(),
        preview: tForm.preview.trim(),
        experience: tForm.experience.trim(),
        modelId: tForm.modelId,
        image: selectedModel ? selectedModel.src : '',
      };
      setConfig((prev) => ({
        ...prev,
        customTestimonials: [...prev.customTestimonials, newItem],
        testimonials: [...prev.testimonials, newId],
      }));
    }
    closeTestimonialModal();
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await saveConfigToApi(config);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    } catch (err) {
      console.error('Error al guardar:', err);
      alert(err?.message || 'Error al guardar la configuración');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-main" style={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative', background: 'var(--admin-bg)' }}>
      {showToast && (
        <div className="admin-toast">
          <span className="material-symbols-outlined" style={{ color: 'var(--admin-primary)', fontSize: '1.25rem' }}>check_circle</span>
          <span style={{ fontSize: '10px', letterSpacing: '0.2em', fontWeight: 700, textTransform: 'uppercase' }}>Configuración guardada</span>
        </div>
      )}

      <header className="admin-home-header">
        <div className="admin-home-header-inner">
          <span className="material-symbols-outlined" style={{ color: 'var(--admin-primary)', fontSize: '1.5rem' }}>home</span>
          <h2 style={{ fontSize: '1.125rem', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', margin: 0 }}>Configuración del Home</h2>
        </div>
        <p className="admin-home-subtitle">
          Las imágenes provienen de la galería (DynamoDB + S3). Sube nuevas fotos en Admin → Galería.
        </p>
      </header>

      <div className="admin-home-tabs">
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            type="button"
            className={`admin-home-tab ${activeSection === s.id ? 'active' : ''}`}
            onClick={() => setActiveSection(s.id)}
          >
            <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>{s.icon}</span>
            {s.label}
          </button>
        ))}
      </div>

      <main className="admin-scroll no-scrollbar" style={{ flex: 1, padding: '0 2.5rem 2rem', maxWidth: '1400px', margin: '0 auto', width: '100%' }}>
        {activeSection === 'galeria' && (
          <div>
            <div className="admin-home-filters">
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button type="button" className="admin-home-filter-btn" onClick={selectAllGaleria}>Seleccionar todos</button>
                <button type="button" className="admin-home-filter-btn" onClick={deselectAllGaleria}>Deseleccionar (mostrar todos)</button>
              </div>
              <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                {config.galeria.length === 0 ? `Mostrando todos (${galleryModels.length})` : `${config.galeria.length} seleccionados`} en Home
              </span>
            </div>
            <div className="admin-home-grid">
              {galleryModels.map((model) => (
                <button
                  key={model.id}
                  type="button"
                  className={`admin-home-item ${config.galeria.length === 0 || config.galeria.includes(model.id) ? 'selected' : ''}`}
                  onClick={() => toggleGaleria(model.id)}
                >
                  <div className="admin-home-item-bg" style={{ backgroundImage: `url(${model.src})` }} />
                  <div className="admin-home-item-overlay">
                    <span className="material-symbols-outlined" style={{ fontSize: '2rem', color: (config.galeria.length === 0 || config.galeria.includes(model.id)) ? 'var(--admin-primary)' : '#666' }}>
                      {(config.galeria.length === 0 || config.galeria.includes(model.id)) ? 'check_circle' : 'radio_button_unchecked'}
                    </span>
                    <span className="admin-home-item-cat">{model.name}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {activeSection === 'estudio' && (
          <div>
            <div className="admin-home-filters">
              <button type="button" className="admin-home-filter-btn" onClick={selectAllEstudio}>Seleccionar todos</button>
              <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                {config.estudio.length} imágenes. En Home se muestran 3 al azar cada 4 segundos.
              </span>
            </div>
            <div className="admin-home-grid">
              {ESTUDIO_IMAGES.map((item) => (
                <button
                  key={item.index}
                  type="button"
                  className={`admin-home-item ${config.estudio.includes(item.index) ? 'selected' : ''}`}
                  onClick={() => toggleEstudio(item.index)}
                >
                  <div className="admin-home-item-bg" style={{ backgroundImage: `url(${item.src})` }} />
                  <div className="admin-home-item-overlay">
                    <span className="material-symbols-outlined" style={{ fontSize: '2rem', color: config.estudio.includes(item.index) ? 'var(--admin-primary)' : '#666' }}>
                      {config.estudio.includes(item.index) ? 'check_circle' : 'radio_button_unchecked'}
                    </span>
                    <span className="admin-home-item-cat">{item.label}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {activeSection === 'beneficios' && (
          <div>
            <div className="admin-home-filters">
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button type="button" className="admin-home-filter-btn" onClick={() => setConfig((prev) => ({ ...prev, beneficios: galleryModels.slice(0, 4).map((m) => m.id) }))}>
                  Primeros 4
                </button>
              </div>
              <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                Selecciona exactamente 4 imágenes de la galería para Beneficios.
              </span>
            </div>
            <div className="admin-home-grid">
              {galleryModels.map((model) => (
                <button
                  key={model.id}
                  type="button"
                  className={`admin-home-item ${config.beneficios.includes(model.id) ? 'selected' : ''}`}
                  onClick={() => toggleBeneficios(model.id)}
                  disabled={!config.beneficios.includes(model.id) && config.beneficios.length >= 4}
                >
                  <div className="admin-home-item-bg" style={{ backgroundImage: `url(${model.src})` }} />
                  <div className="admin-home-item-overlay">
                    <span className="material-symbols-outlined" style={{ fontSize: '2rem', color: config.beneficios.includes(model.id) ? 'var(--admin-primary)' : '#666' }}>
                      {config.beneficios.includes(model.id) ? 'check_circle' : 'radio_button_unchecked'}
                    </span>
                    <span className="admin-home-item-cat">{model.name}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {activeSection === 'testimonios' && (
          <div>
            <div className="admin-home-filters">
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                <button type="button" className="admin-home-filter-btn" onClick={selectAllTestimonials}>Seleccionar todos</button>
                <button type="button" className="admin-home-filter-btn" onClick={deselectAllTestimonials}>Deseleccionar</button>
                <button type="button" className="admin-home-filter-btn admin-home-filter-btn--accent" onClick={openNewTestimonial}>
                  <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>add</span>
                  Nueva Experiencia
                </button>
              </div>
              <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                {config.testimonials.length} seleccionados para Testimonios en Home
              </span>
            </div>
            <div className="admin-home-grid">
              {allTestimonials.map((item) => (
                <div key={item.id} className="admin-home-testimonial-wrapper">
                  <button
                    type="button"
                    className={`admin-home-item ${config.testimonials.includes(item.id) ? 'selected' : ''}`}
                    onClick={() => toggleTestimonials(item.id)}
                  >
                    <div className="admin-home-item-bg" style={{ backgroundImage: `url(${item.image})` }} />
                    <div className="admin-home-item-overlay">
                      <span className="material-symbols-outlined" style={{ fontSize: '2rem', color: config.testimonials.includes(item.id) ? 'var(--admin-primary)' : '#666' }}>
                        {config.testimonials.includes(item.id) ? 'check_circle' : 'radio_button_unchecked'}
                      </span>
                      <span className="admin-home-item-cat">{item.name}</span>
                      <span className="admin-home-item-cat" style={{ fontSize: '0.65rem', opacity: 0.9 }}>{item.tag}</span>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="admin-home-testimonial-edit-btn"
                    title="Editar experiencia"
                    onClick={(e) => { e.stopPropagation(); openEditTestimonial(item); }}
                  >
                    <span className="material-symbols-outlined">edit</span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {showTestimonialModal && (
          <div className="admin-home-modal-backdrop" onClick={closeTestimonialModal}>
            <div className="admin-home-modal" onClick={(e) => e.stopPropagation()}>
              <div className="admin-home-modal-header">
                <h3>{editingTestimonialId !== null ? 'Editar Experiencia' : 'Nueva Experiencia'}</h3>
                <button type="button" className="admin-home-modal-close" onClick={closeTestimonialModal}>
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>

              <div className="admin-home-modal-body no-scrollbar">
                <label className="admin-home-modal-label">Imagen / Modelo (de la galería)</label>
                <div className="admin-home-modal-image-grid no-scrollbar">
                  {galleryModels.map((m) => (
                    <button
                      key={m.id}
                      type="button"
                      className={`admin-home-modal-image-item ${tForm.modelId === m.id ? 'selected' : ''}`}
                      onClick={() => setTForm((p) => ({ ...p, modelId: m.id }))}
                    >
                      <img src={m.src} alt={m.name} />
                      {tForm.modelId === m.id && (
                        <span className="admin-home-modal-image-check material-symbols-outlined">check_circle</span>
                      )}
                    </button>
                  ))}
                </div>

                <label className="admin-home-modal-label" htmlFor="t-name">Nombre</label>
                <input
                  id="t-name"
                  className="admin-home-modal-input"
                  type="text"
                  placeholder="Nombre de la modelo"
                  value={tForm.name}
                  onChange={(e) => setTForm((p) => ({ ...p, name: e.target.value }))}
                />

                <label className="admin-home-modal-label" htmlFor="t-tag">Etiqueta / Tag</label>
                <input
                  id="t-tag"
                  className="admin-home-modal-input"
                  type="text"
                  placeholder="Ej: Platinum Model"
                  value={tForm.tag}
                  onChange={(e) => setTForm((p) => ({ ...p, tag: e.target.value }))}
                />

                <label className="admin-home-modal-label" htmlFor="t-preview">Preview (texto corto)</label>
                <input
                  id="t-preview"
                  className="admin-home-modal-input"
                  type="text"
                  placeholder="Breve resumen de la experiencia"
                  value={tForm.preview}
                  onChange={(e) => setTForm((p) => ({ ...p, preview: e.target.value }))}
                />

                <label className="admin-home-modal-label" htmlFor="t-experience">Experiencia completa</label>
                <textarea
                  id="t-experience"
                  className="admin-home-modal-textarea"
                  rows={5}
                  placeholder="Escribe la experiencia completa aquí..."
                  value={tForm.experience}
                  onChange={(e) => setTForm((p) => ({ ...p, experience: e.target.value }))}
                />
              </div>

              <div className="admin-home-modal-footer">
                <button type="button" className="admin-home-modal-cancel" onClick={closeTestimonialModal}>Cancelar</button>
                <button
                  type="button"
                  className="admin-home-modal-save"
                  disabled={!tForm.name.trim() || !tForm.experience.trim()}
                  onClick={saveTestimonial}
                >
                  {editingTestimonialId !== null ? 'Guardar Cambios' : 'Crear Experiencia'}
                </button>
              </div>
            </div>
          </div>
        )}
      </main>

      <footer className="admin-home-footer">
        <button type="button" className="admin-home-save" onClick={handleSave} disabled={saving}>
          {saving ? 'Guardando...' : 'Guardar Cambios'}
        </button>
      </footer>
    </div>
  );
}

export default HomeAdminPage;
